import axios from "@/libs/api.request";

// 获取仓库管理的列表
export const getStock = params => {
  return axios.request({
    url: "/warehouse/stock",
    method: "get",
    params
  });
};

export const getShelvesLog = params => {
  return axios.request({
    url: "/warehouse/onShelvesLog",
    method: "get",
    params
  });
};

export const getPickupLog = params => {
  return axios.request({
    url: "/warehouse/onPickupLog",
    method: "get",
    params
  });
};

export const getOutLog = params => {
  return axios.request({
    url: "/warehouse/onOutLog",
    method: "get",
    params
  });
};
